<template>
  <div style="display: none;">
    <!-- SEO Head component - meta tags will be injected -->
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { useHead } from '@vueuse/head'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  keywords: {
    type: String,
    default: ''
  },
  image: {
    type: String,
    default: 'https://webservices.vn/images/og-image.webp'
  },
  url: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'website'
  },
  author: {
    type: String,
    default: 'Web Services'
  },
  publishedTime: {
    type: String,
    default: ''
  },
  modifiedTime: {
    type: String,
    default: ''
  }
})

// Generate canonical URL
const canonicalUrl = props.url || (typeof window !== 'undefined' ? window.location.href : '')

// Generate meta tags
const metaTags = [
  // Basic meta tags
  { name: 'description', content: props.description },
  { name: 'keywords', content: props.keywords },
  { name: 'author', content: props.author },
  
  // Open Graph tags
  { property: 'og:title', content: props.title },
  { property: 'og:description', content: props.description },
  { property: 'og:image', content: props.image },
  { property: 'og:url', content: canonicalUrl },
  { property: 'og:type', content: props.type },
  { property: 'og:site_name', content: 'Web Services' },
  { property: 'og:locale', content: 'vi_VN' },
  
  // Twitter Card tags
  { name: 'twitter:card', content: 'summary_large_image' },
  { name: 'twitter:title', content: props.title },
  { name: 'twitter:description', content: props.description },
  { name: 'twitter:image', content: props.image },
  
  // Additional meta tags
  { name: 'robots', content: 'index, follow' },
  { name: 'googlebot', content: 'index, follow' },
  { name: 'bingbot', content: 'index, follow' },
  
  // Article specific tags
  ...(props.publishedTime ? [{ property: 'article:published_time', content: props.publishedTime }] : []),
  ...(props.modifiedTime ? [{ property: 'article:modified_time', content: props.modifiedTime }] : []),
  ...(props.type === 'article' ? [{ property: 'article:author', content: props.author }] : [])
]

// Inject meta tags into head
useHead({
  title: props.title,
  meta: metaTags,
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl
    }
  ]
})
</script>
